import { render, staticRenderFns } from "./detailsBash.vue?vue&type=template&id=8abda326&scoped=true&"
import script from "./detailsBash.vue?vue&type=script&lang=js&"
export * from "./detailsBash.vue?vue&type=script&lang=js&"
import style0 from "./detailsBash.vue?vue&type=style&index=0&id=8abda326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abda326",
  null
  
)

export default component.exports